import * as _ from 'lodash';
import { formValueSelector } from 'redux-form';

export const FORM_NAME = 'auto';

// set destroyOnUnmount / forceUnregisterOnUnmount because the auto loan form
// spans multiple pages: https://redux-form.com/6.6.3/examples/wizard/
// and set enableReinitialize so we reset initial values even when the
// user goes down a path, clicks back, and goes down a different one
export const FORM_CONFIG = {
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  form: FORM_NAME,
};

export type AutoFormField = 'autoLoanPurposeType' | 'autoRefinanceType' | 'autoVehicleCondition';
export type AutoModelProperties = { [key in AutoFormField]?: string };

export const FIELDS: { [key: string]: AutoFormField } = {
  autoLoanPurposeType: 'autoLoanPurposeType',
  autoRefinanceType: 'autoRefinanceType',
  autoVehicleCondition: 'autoVehicleCondition',
};

export const selector = formValueSelector(FORM_NAME);

export function getModelProperties(state: ReduxState) {
  if (state.form.auto) {
    // if we've gone through auto onboarding, manually build an object with
    // values, albeit only truthy values because /api/borrowers complains if
    // we send a null (but do return undefined if no values are saved)
    const modelProperties = _.pickBy(_.mapValues(FIELDS, field => selector(state, field))) as AutoModelProperties;

    if (_.keys(modelProperties).length > 0) {
      return modelProperties;
    }
  }
}
